<template>
    <div class="change-phone">
        <h5 class="change-phone__title">{{ messages.title }}</h5>
        <p v-if="step === 'phone'" class="change-phone__text">{{ messages.sub_title }}</p>
        <div v-else class="change-phone__send-text">
            <p class="change-phone__text">
                {{ messages.send_title }}
            </p>
            <p class="change-phone__text">
                {{ getPhone }}
            </p>
            <span @click="step = 'phone'" class="change-phone__return">
                {{ messages.change_phone_title }}
            </span>
        </div>
<!--        <div v-if="result.error">-->
<!--            {{ result.error }}-->
<!--        </div>-->
        <form ref="main" :action="result.action" @submit.prevent="handlerSubmitForm" class="change-phone__form">
            <input v-for="field in result.fields" type="hidden" :value="field.value" :name="field.name">
            <input type="hidden" v-if="step === 'phone'" value="sendSMScode" name="action">
            <input type="hidden" v-if="step === 'code'" value="compareSMScode" name="action">
            <DefPhone
                v-if="step === 'phone'"
                placeholder="Телефон"
                name="phone"
                :value="value"
                :required="true"
                class="change-phone__input"
                ref="phoneInput"
            />
            <!--                @input="showValue"-->

            <def-input v-else name="code"
                       :label="messages.code_placeholder"
                       class="change-phone__input"
            />

            <p v-if="step === 'code'" class="change-phone__time" v-html="showResendText"></p>
            <p v-if="error" class="change-phone__error">{{ error }}</p>
            <button type="submit" v-if="step === 'phone'" class="def-button">
                {{ messages.btn_title }}
            </button>
            <button type="submit" v-else-if="step === 'code' && timer > 0" class="def-button">
                {{ messages.confirm }}
            </button>
        </form>
        <button v-if="timer === 0"
                class="def-button"
                @click="sendAgain"
        >
            {{ messages.resend }}
        </button>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DefPhone from "../def/DefPhone/DefPhone";

export default {
    name: 'change-phone',
    selector: '.change-phone',
    props: ['result'],
    components: {
        DefPhone
    },
    data() {
        return {
            step: 'phone', // phone or code
            timer: 90,
            timeOut: null,
            messages:this.result.messages,
            value: '',
            trigger: false,
            phone: ''
        }
    },
    computed: {
        showResendText() {
            return this.messages.timer_text.replace("#", this.timer);
        },
        getPhone() {
            return this.value;
        },
        ...mapState({
            error: ({ personalCabinet }) => personalCabinet.data.changePhoneFields?.error,
            setPhone: ({personalCabinet}) => personalCabinet.data.setPhoneResult,
        })
    },
    methods: {
       handlerSubmitForm({target}, again) {
            let formData = BX.ajax.prepareForm(this.$refs.main).data;
            let ajaxUrl = $(this.$refs.main).attr('action');

            //let step = this.step;
            const _this = this;
            let data = {};
            if (!again) {
                data = {formData: new FormData(target),url:ajaxUrl};
                this.phone = data.formData.get('phone');
            } else {
                const formData = new FormData(this.$refs.main);
                formData.set('action', 'sendSMScode');
                formData.delete('code');
                formData.append('phone', `${this.phone}`)
                data = {formData: formData,url:ajaxUrl}

            }
          let response = this.$store.dispatch('personalCabinet/checkPhone', data);
           response.then(() => {
               console.log(this.error)
               if(!this.error) {
                   if (this.step === 'phone') {
                       this.step = 'code';
                       this.updateTimer();
                   }
               } else {
                   this.step = 'phone';
               }
           })


        },
        close(){


            this.$emit('close');
        },
        // showValue(e){
        //     this.value = e;
        // },
        updateTimer() {
            this.timeOut = setTimeout(() => {
                this.timer = this.timer - 1;
                if (this.step !== 'code') {
                    clearTimeout(this.timeOut);
                    this.timer = 90;
                } else if (this.timer > 0) {
                    this.updateTimer();
                } else {
                    // done your code
                }
            },1000);
        },
        sendAgain(){
            this.timer = 90;
            this.handlerSubmitForm(event, 'again');
            this.updateTimer();
        }
    },
    mounted(){
    }

}
</script>

<style lang="scss" scoped>
.change-phone{
    text-align: center;
    &__error{
        color: #FF0000;
    }
    &__title{
        font-weight: 500;
        font-size: rem(14);
        line-height: 115%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        text-align: center;
        margin-bottom: 24px;
        @include point-md{
            font-size: rem(18);
            line-height: 110%;
        }
    }
    &__text{
        font-weight: 500;
        font-size: rem(14);
        line-height: 100%;
        color: #191918;
        text-align: center;
        @include point-md{
            font-size: rem(16);
            line-height: 110%;
        }
    }
    &__return{
        font-weight: 500;
        font-size: rem(14);
        line-height: 100%;
        color: var(--text-colour-secondary);
        @include point-md{
            font-size: rem(16);
            line-height: 110%;
        }
        cursor: pointer;
    }
    &__time{
        font-size: rem(14);
        line-height: 100%;
        color: #757575;
        margin-bottom: 24px;
    }
    .def-button{
        width: 100%;
    }

    ::v-deep{
        .def-phone-wrapper,
        .def-phone{
            display: block;
            margin-top: 24px;
            margin-bottom: 16px;
            input{
                width: 100%;
            }
        }
    }
}
</style>